import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { DiadnosissearchComponent } from './diadnosissearch/diadnosissearch.component';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-diagnosis-master',
  templateUrl: './diagnosis-master.component.html',
  styleUrls: ['./diagnosis-master.component.scss']
})
export class DiagnosisMasterComponent implements OnInit {
  destroydiagmaster$: Subject<boolean> = new Subject<boolean>();
  private categorydataList: any;
  private disableupdatebutton: boolean = true;
  private showspinner: boolean = false;
  private departmentName: string = "";
  private CategoryName: string = "";
  private CategoryCode: string = "";
  private departmentid: number = 0;
  private categoryid: number = 0;
  private diagonisisName: string = '';
  private diagnosisdata: any = [];
  private diagonisicatid: number = 0;
  private diagonisCode: string = '';
  private disableaddmaster: boolean = false;
  private enabledisablebtn: boolean = false
  private enabledisablebtnMstDia = false;
  filteredCatTypeArray: Observable<any[]>;
  private SelecteddiagonsisArray: any = []
  isheader: boolean = false;
  private isActive: boolean = false;
  myControl: FormControl;
  @ViewChild('categoryname', { static: false }) private CategorynameRef: ElementRef;
  @ViewChild('diagnosisName', { static: false }) private DiagnosisRef: ElementRef;
  constructor(private emrservice: EMRService,
    private dialog: MatDialog,
    private dashboardService: DashboardService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DiagnosisMasterComponent>,
  ) { }

  ngOnInit(): void {
    this.myControl = new FormControl();
    this.diagonisicatid = 0;
    this.diagnosisdata = [];
    this.SelecteddiagonsisArray = [];
    this.disableaddmaster = true;
    this.diagonisisName = '';
    this.CategoryName = '';
    this.isActive = true;
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
    this.diagonisisCategory(0);
    this.GetGetDiagnosis(0, 0, 0);

  }
  cleardata() {
    // this.diagnosisdata = [];
    // this.SelecteddiagonsisArray = [];
    this.categoryid = null
    this.diagonisicatid = null
    this.disableaddmaster = true;
    this.diagonisisName = '';
    this.CategoryName = '';
    this.CategoryCode = ''
    this.isActive = true;
  }
  diagonisisCategory(diaid) {
    this.emrservice.GetDiagonisCategory(diaid).pipe(takeUntil(this.destroydiagmaster$)).subscribe((data:any) => {
      this.categorydataList = data.filter(item => item.isActive == true);
      this.catTypeControll();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  GetGetDiagnosis(diagonisiid, searchname, searchtype) {
    this.emrservice.GetGetDiagnosismaster(diagonisiid,searchname,searchtype).pipe(takeUntil(this.destroydiagmaster$)).subscribe(data => this.sucees_dagonisdata(data), err => this.err_daigonsis(err));
  }
  sucees_dagonisdata(data) {
    this.diagnosisdata = [];
    if (data.length > 0) {
      this.diagnosisdata = data;
      //  this.diagnosis_ds = new MatTableDataSource(this.diagnosisdata.slice());
    }
  }
  err_daigonsis(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  catTypeControll() {
    this.myControl = new FormControl();
    this.filteredCatTypeArray = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterOpfunction(cat) : this.categorydataList.slice())
      );
  }

  filterOpfunction(name: string) {
    const len = Object.keys(name).length;
    if (len > 9) {
      return this.categorydataList.filter(category =>
        category.categoryName?.toLowerCase().indexOf(name) === 0);
    } else {

      return this.categorydataList.filter(category =>
        category.categoryName?.toLowerCase().indexOf(name?.toLowerCase()) === 0);
    }

  }

  CheckinputOpType(event: any) {
    this.enabledisablebtnMstDia = false;
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.catTypeControll();
    }
  }
  CheckinputType(event) {
    this.enabledisablebtnMstDia = false;
  }

  ChangeCategory(e: any, type: any) {
    switch (type) {
      case (1): {
        this.CategoryName = e;
        this.enabledisablebtnMstDia = false;
        break;
      }
      case (2): {
        this.CategoryCode = e;
        this.enabledisablebtnMstDia = false;
        break;
      }
      case (3): {
        if (e == false) {
          this.isActive = true;
          this.enabledisablebtnMstDia = false;
        } else {
          this.isActive = false;
          this.enabledisablebtnMstDia = false;
        }
        break;
      }
    }
    this.enabledisablebtn = false;
  }

  openSearchCategory(): void {
    const dialogRef = this.dialog.open(DiadnosissearchComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '95vw',
      width: '95%',
      // height:'90%',
      disableClose: true,
      data: {
        disableaddmaster: this.disableaddmaster = false
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroydiagmaster$)).subscribe(result => {
      if (result != 0) {
        this.disableupdatebutton = false;
        this.diagonisicatid = result.fK_DgCategoryId;
        this.categoryid = result.pk_DiagnosisId;
        this.CategoryName = this.categorydataList.filter(res => res.pk_DiagnosisCatId === result.fK_DgCategoryId)[0]?.categoryName;
        this.CategoryCode = result.icdCode;
        this.diagonisisName = result.diagnosisName;
        this.isActive = result.isActive;
      }
    });
  }


  diagonisisNameValidation: boolean = false;
  categoryNameValidation: boolean = false;
  AddMaster(event) {
    if (!this.CategoryName || this.CategoryName.trim() === '') {
      // this.categoryNameValidation = true;
      this.dashboardService.openSnackBar("Please Select Category Name", "OK");
      return;
    }
    const isCategoryName = this.categorydataList.some(cat => cat.categoryName == this.CategoryName);
    if (!isCategoryName) {
      this.dashboardService.openSnackBar("Please Select a Valid Category Name", "OK");
      return;
    }

    if (this.diagonisicatid > 0) {
      if (this.diagonisisName != '') {
        if (this.categoryid > 0) {
          let diagnosisid = this.diagnosisdata.filter(item => item.fK_DgCategoryId == item.fK_DgCategoryId);
          let payload = {
            "Pk_DiagnosisId": this.categoryid,
            "FK_DgCategoryId": this.diagonisicatid,
            "ICDCode": this.CategoryCode,
            "DiagnosisName": this.diagonisisName.replace(/^\s+|\s+$/gm,''),
            "IsHeading": true,
            "IsActive": this.isActive,
            "IsHidden": 0
          }
          this.emrservice.SaveDaigonsisData(payload).pipe(takeUntil(this.destroydiagmaster$)).subscribe((x: any) => {
            if (x.statusCode == 1) {
              let dainsisid = x['id'];
              let diagnosisfilter;
              diagnosisfilter = diagnosisid.filter(item => item.diagnosisName == item.diagnosisName);
              diagnosisid.pk_DiagnosisId = dainsisid;
              this.enabledisablebtnMstDia = true;
              this.diagonisicatid = 0;
              this.disableaddmaster = true;
              this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
              this.GetGetDiagnosis(0, 0, 0);
              this.cleardata()
            }
          }, err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
        } else {
          const checkdaiename = this.diagnosisdata.filter(item => item.diagnosisName.toLowerCase() == this.diagonisisName.toLowerCase());
          if (checkdaiename.length > 0) {
            this.dashboardService.openSnackBar("Already exists in the list", "OK");
          } else {
            let diagnosisid = this.diagnosisdata.filter(item => item.fK_DgCategoryId == item.fK_DgCategoryId);
            let payload = {
              "Pk_DiagnosisId": 0,
              "FK_DgCategoryId": this.diagonisicatid,
              "ICDCode": this.CategoryCode,
              "DiagnosisName": this.diagonisisName.replace(/^\s+|\s+$/gm,''),
              "IsHeading": true,
              "IsActive": this.isActive,
              "IsHidden": 0
            }
            this.emrservice.SaveDaigonsisData(payload).pipe(takeUntil(this.destroydiagmaster$)).subscribe((x: any) => {
              let dainsisid = x['id'];
              diagnosisid.pk_DiagnosisId = dainsisid;
              this.enabledisablebtnMstDia = true;
              this.diagonisicatid = 0;
              this.disableaddmaster = true;
              this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
              this.GetGetDiagnosis(0, 0, 0);
              this.cleardata()
            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
          }
        }
      } else {
        this.dashboardService.openSnackBar("Please Select  Diagnosis Name", "OK");
        this.diagonisisNameValidation = true;
        setTimeout(() => {
          this.DiagnosisRef.nativeElement.focus();
        }, 100);
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Category  Name", "OK");
      setTimeout(() => {
        this.CategorynameRef.nativeElement.focus();
      }, 100);
      this.categoryNameValidation = true;
    }
  }

  selectDaigonsis(fK_DgCategoryId) {
    if (fK_DgCategoryId > 0) {
      this.diagonisicatid = fK_DgCategoryId;
      // this.diagnosis_ds.data = this.diagnosisdata.filter(item => item.fK_DgCategoryId == fK_DgCategoryId);
    } else {
      // this.diagnosis_ds.data = this.diagnosisdata;
    }
    this.disableaddmaster = false;
    this.enabledisablebtnMstDia = false;
  }
  closedialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroydiagmaster$.next(true);
    this.destroydiagmaster$.unsubscribe();
    this.diagnosisdata = null;
    this.SelecteddiagonsisArray = null;
    this.disableaddmaster = null;
    this.diagonisicatid = null;
    this.diagonisCode = null;
    this.diagonisisName = null;
    this.filteredCatTypeArray = null;
    this.isActive = null;
  }
}
